import {
  ForwardedRef,
  Ref,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import ReactPlayer from "react-player";
import { OnProgressProps } from "react-player/base";
import useHomeworkState from "../state/homework.state";
import AudioManager, { AudioManagerHandle } from "./AudioManager";

export type VoiceOverManagerHandle = {
  onPlay: () => void;
  onPause: () => void;
  onSeek: () => void;
  onProgress: (videoProgress: OnProgressProps) => Promise<void>;
};

type Props = {
  videoRef: ReactPlayer;
  isDisabled?: boolean;
};

const VoiceOverManager = (
  { videoRef, isDisabled = false }: Props,
  ref: ForwardedRef<VoiceOverManagerHandle>,
) => {
  const audioManagerRef = useRef<AudioManagerHandle>(null);
  const { voiceOvers, setVoiceOvers } = useHomeworkState();

  useImperativeHandle(
    ref,
    () => ({
      onPlay: () => audioManagerRef.current?.onPlay(),
      onPause: () => audioManagerRef.current?.onPause(),
      onSeek: () => audioManagerRef.current?.onSeek(),
      onProgress: async (progress) =>
        audioManagerRef.current?.onProgress(progress, 0),
    }),
    [],
  );

  return (
    <AudioManager
      audios={voiceOvers}
      setAudios={setVoiceOvers}
      videoRef={videoRef}
      ref={audioManagerRef}
      isDisabled={isDisabled}
    />
  );
};

export default forwardRef(VoiceOverManager) as (
  props: Props & { ref?: Ref<VoiceOverManagerHandle> },
) => JSX.Element;
